export default {
    'SET_EMPRESA'(state, empresa) {
        state.empresa = empresa
    },

    'SET_USUARIOS'(state, usuarios){
        state.usuarios = usuarios
    },

    'SET_PERMISSOES'(state, permissoes){
        state.permissoes = permissoes
    },

    'SET_GRUPOS'(state, grupos) {
        state.grupos = grupos
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/usuario/mutations.js